import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { DirectoryRequest } from '../interfaces/directory.interface';

@Injectable({ providedIn: 'root' })
export class DirectoryService {

    constructor(private readonly http: HttpClient) {}

    /**
     * Busca diretórios com paginação para uso em TreeView com lazy loading
     */
    getDirectories(params: {
        parentId: string | null;
        page: number;
        limit: number;
        shareable: boolean;
        isFtp?: boolean;
        sharedWithMe?: boolean;
    }): Observable<any> {
        const headers = new HttpHeaders({ 'Content-Type': 'application/json'});
        let httpParams = new HttpParams()
            .set('page', params.page.toString())
            .set('limit', params.limit.toString())
            .set('shareable', params.shareable.toString());

        if (params.isFtp !== undefined) {
            httpParams = httpParams.set('isFtp', String(params.isFtp));
        }

        if (params.sharedWithMe !== undefined) {
            httpParams = httpParams.set('sharedWithMe', String(params.sharedWithMe));
        }

        if (params.parentId) {
            httpParams = httpParams.set('parentId', params.parentId);
        }

        return this.http.get<any>(`${environment.apiUrls.coreApi}/nodes`, { params: httpParams, headers });
    }

    getDirectory(id: string): Observable<any> {
        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        return this.http.get<any>(`${environment.apiUrls.coreApi}/nodes/${id}`, { headers });
    }

    getPath(id: string): string {
        return `${environment.apiUrls.coreApi}/nodes/${id}/path?shareable=false`;
    }

    save(request: DirectoryRequest)  {

        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });

        !request.parentId && delete request.parentId;

        const directoryId = request?.id
        delete request.id;

        if (directoryId) {
            return this.http.patch<any>(`${environment.apiUrls.coreApi}/nodes/${directoryId}/rename`, request, { headers });
        }

        return this.http.post<any>(`${environment.apiUrls.coreApi}/nodes`, request, { headers });
    }

    delete(params: { directoryId: string }) {
        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });

        return this.http.delete<any>(`${environment.apiUrls.coreApi}/nodes/${params.directoryId}`, { headers });
    }

    moveNode(nodeId: string, destinationId: string, nodeType?: string): Observable<any> {
        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        let params = new HttpParams();
        const body: any = {};

        if (destinationId) {
            params = params.set('destinationId', destinationId);
            body.destinationId = destinationId;
        }

        if (nodeType) {
            body.nodeType = nodeType;
        }

        return this.http.put<any>(`${environment.apiUrls.coreApi}/nodes/${nodeId}/move`, body, { headers, params });
    }
}
